import React, { useRef } from 'react';
import { MoreHorizontal } from 'lucide-react';
import { Trash } from 'lucide-react';
import { Flag } from 'lucide-react';
import { DropdownMenu, DropdownMenuItem, Tag, cn } from '@edusense/shared-ui-kit';
import { ContentMediaGrid } from '@edusense/entities-media';
import { ProjectStats } from '../ProjectStats';
import { SocialHeader } from '@edusense/shared-ui-layout';
import { CardContainer, HoverBackground, MenuButtonContainer, MenuButton, ProjectTitle, ProjectDescription } from './styles';
export var ProjectCardDefault = function(param) {
    var project = param.project, isMenuOpen = param.isMenuOpen, onMenuToggle = param.onMenuToggle, onMenuClose = param.onMenuClose, onViewDetails = param.onViewDetails, onLike = param.onLike, onComment = param.onComment, onDelete = param.onDelete, onReport = param.onReport, onClick = param.onClick, className = param.className, _param_showActions = param.showActions, showActions = _param_showActions === void 0 ? true : _param_showActions, isOwner = param.isOwner, isAuthenticated = param.isAuthenticated, hasMedia = param.hasMedia, allMediaUrls = param.allMediaUrls, filterImageUrls = param.filterImageUrls, filterVideoUrls = param.filterVideoUrls, filterShortFormUrls = param.filterShortFormUrls;
    var defaultMenuTriggerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(CardContainer, {
        isCompact: false,
        className: cn(className),
        onClick: onClick || onViewDetails
    }, /*#__PURE__*/ React.createElement(HoverBackground, null), showActions && /*#__PURE__*/ React.createElement(MenuButtonContainer, {
        isDefault: true
    }, /*#__PURE__*/ React.createElement(MenuButton, {
        ref: defaultMenuTriggerRef,
        isDefault: true,
        onClick: function(e) {
            e.stopPropagation();
            onMenuToggle();
        },
        "aria-label": "프로젝트 설정"
    }, /*#__PURE__*/ React.createElement(MoreHorizontal, {
        className: "w-4 h-4"
    })), isMenuOpen && /*#__PURE__*/ React.createElement(DropdownMenu, {
        isOpen: isMenuOpen,
        onClose: onMenuClose,
        triggerRef: defaultMenuTriggerRef
    }, isOwner && onDelete && /*#__PURE__*/ React.createElement(DropdownMenuItem, {
        icon: /*#__PURE__*/ React.createElement(Trash, {
            size: 16
        }),
        onClick: onDelete,
        className: "text-red-600 hover:bg-red-50"
    }, "삭제하기"), !isOwner && isAuthenticated && onReport && /*#__PURE__*/ React.createElement(DropdownMenuItem, {
        icon: /*#__PURE__*/ React.createElement(Flag, {
            size: 16
        }),
        onClick: onReport,
        className: "text-red-600 hover:bg-red-50"
    }, "신고하기"))), /*#__PURE__*/ React.createElement("div", {
        className: "space-y-4"
    }, /*#__PURE__*/ React.createElement(SocialHeader, {
        author: {
            id: project.author.id,
            name: project.author.name,
            username: project.author.username || project.author.id,
            profileImageUrl: project.author.profileImageUrl || project.author.avatar || project.author.profileImage
        },
        createdAt: new Date(project.createdAt),
        verified: project.author.verified,
        featured: project.featured
    }), hasMedia && /*#__PURE__*/ React.createElement(ContentMediaGrid, {
        images: filterImageUrls(allMediaUrls),
        videos: filterVideoUrls(allMediaUrls),
        shortFormVideos: filterShortFormUrls(allMediaUrls),
        className: "mt-2",
        useBuiltInModal: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: "space-y-2"
    }, /*#__PURE__*/ React.createElement(ProjectTitle, {
        $isCompact: false
    }, project.title), /*#__PURE__*/ React.createElement(ProjectDescription, {
        $isCompact: false
    }, project.description), project.tags && project.tags.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap gap-2 mt-2"
    }, project.tags.map(function(tag) {
        return /*#__PURE__*/ React.createElement(Tag, {
            key: tag,
            text: tag
        });
    }))), /*#__PURE__*/ React.createElement(ProjectStats, {
        views: project.views,
        likes: project.likes,
        comments: project.comments,
        onLikeClick: onLike,
        onCommentClick: onComment
    })));
};
export default ProjectCardDefault;
